(() => {
  'use strict';

  const ROOT_SELECTOR = '[data-pit]';

  function initTabs(root) {
    if (root.dataset.pitInitialized === 'true') return;
    root.dataset.pitInitialized = 'true';

    const tabs = Array.from(root.querySelectorAll('[data-pit-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-pit-panel]'));

    if (!tabs.length || !panels.length) return;

    function activateTab(selectedTab, moveFocus = false) {
      const selectedName = selectedTab.dataset.pitTab;

      tabs.forEach(tab => {
        const active = tab === selectedTab;

        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });

      panels.forEach(panel => {
        panel.hidden = panel.dataset.pitPanel !== selectedName;
      });

      if (moveFocus) selectedTab.focus();
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        activateTab(tab);
      });

      tab.addEventListener('keydown', event => {
        let nextIndex = index;

        if (event.key === 'ArrowRight') {
          nextIndex = (index + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft') {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        activateTab(tabs[nextIndex], true);
      });
    });

    const initialTab =
      tabs.find(tab => tab.getAttribute('aria-selected') === 'true') ||
      tabs[0];

    activateTab(initialTab);
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();